import { Base } from "@models/base";
import { SubscriberAttributeItem } from "./subscriber_attribute_item";

export class SubscriberAttributeSet extends Base {
  name: string;
  attributeId: number;
  attributeSetId: number;
  attributeItems: SubscriberAttributeItem[];
}
